import { VSecureFileShredRequest, VSecureFileShredResponse } from '@datarock/protobuffers';
import { EncryptedEndpoint } from './Encrypted';
class ShredFileEndpoint extends EncryptedEndpoint {
    async getRequestInit({ fileId }) {
        const requestBytes = VSecureFileShredRequest.encode({
            fileId
        }).finish();
        return await super.getRequestInit(requestBytes);
    }
    async process(value, ...args) {
        const responseBytes = await super.process(value, ...args);
        return VSecureFileShredResponse.decode(responseBytes);
    }
}
export const shredEndpoint = new ShredFileEndpoint({
    path: '/encryptions/shred',
    method: 'POST',
    sideEffect: true,
    body: {},
    schema: VSecureFileShredResponse
});
